import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material';

type MuiPopover = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiPopover'];
  defaultProps?: ComponentsProps['MuiPopover'];
  variants?: ComponentsVariants['MuiPopover'];
};

export const MuiPopover: MuiPopover = {
  styleOverrides: {
    paper: {
      marginTop: 4,
    },
  },
};
